export default "__VITE_ASSET__jsqoVco8__"